
// 0.1s of silence in mp3, bsae64 encoded.
//export const silentDataURI = "data:audio/mpeg;base64,//uQxAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAACcQCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//sQxAADgnABGiAAABFZ2xpbmcgbGV2ZWwgc2lsZW5jZQ==";
export const silentDataURI = "data:audio/mpeg;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjYwLjE2LjEwMAAAAAAAAAAAAAAA/+M4wAAAAAAAAAAAAEluZm8AAAAPAAAABAAAAfgAkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKStra2tra2tra2tra2tra2tra2tra2tra2ttvb29vb29vb29vb29vb29vb29vb29vb29v/////////////////////////////////AAAAAExhdmM2MC4zMQAAAAAAAAAAAAAAACQDoAAAAAAAAAH4QRrVIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MYxAAAAANIAAAAAExBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxDsAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxHYAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxLEAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";

export class AudioPlayer {
	audio;

	constructor() {
		this.audio = new Audio();
	}

	async init( url ) {
		if ( !url ) {
			url = silentDataURI;
		}

		this.setSrc( url );
		return this.play();
	}

	parseBase64( base64_text ) {
		return Uint8Array.from( atob( base64_text ), c => c.charCodeAt(0) );
	}
	async playFromBase64( base64_audio ) {
		const audioData = this.parseBase64( base64_audio );
		const audioBlob = new Blob( [audioData], { type: 'audio/mpeg' });
		const url = URL.createObjectURL( audioBlob );
		this.setSrc( url );
		return this.play();
	}

	setSrc( url ) {
		this.audio.src = url;
	}

	async play() {
		return this.audio.play();
	}

	async pause() {
		return this.audio.pause();
	}

}